import { useState } from 'react';
import { useSreOpenBugTrend } from '../../../hooks/useSreOpenBugTrend.js';
import { SreOpenBugTrendChart } from './SreOpenBugTrendChart.js';
import type { SreOpenBugTrendUnit } from '../../../types/sre-open-bug-trend.js';

/**
 * SRE 未完了バグ件数の増減セクション。集計単位の状態とデータ取得を内包し、
 * SreOpenBugTrendChart を描画するコンテナコンポーネント。
 * SRE ビューのときだけ描画するので、他のチームを見ている間は取得しない
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business KPI画面のSREビューのコンテナ。週次/月次/半期の集計単位状態を保持し、未完了バグ件数の増減データを取得してチャートカードを表示
 * @graph-connects useSreOpenBugTrend [calls] 未完了バグ件数の増減データ取得
 * @graph-connects SreOpenBugTrendChart [calls] 未完了バグ件数の増減チャートカード描画
 */
export function SreOpenBugTrendSection() {
  const [unit, setUnit] = useState<SreOpenBugTrendUnit>('week');
  const { data, isLoading } = useSreOpenBugTrend({ unit });

  return (
    <SreOpenBugTrendChart
      data={data?.data ?? []}
      startDate={data?.startDate}
      isLoading={isLoading}
      unit={unit}
      onUnitChange={setUnit}
    />
  );
}
